import { Component } from '@angular/core';

@Component({
  selector: 'app-ticke-ticket-caisse',
  templateUrl: './ticke-ticket-caisse.component.html',
  styleUrls: ['./ticke-ticket-caisse.component.scss'],
})
export class TickeTicketCaisseComponent {}
